import { Navigate, Route, Routes } from 'react-router-dom';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { AgentSettings } from './pages/AgentSettings';
import { KnowledgeBase } from './pages/KnowledgeBase';
import { Conversations } from './pages/Conversations';
import { Leads } from './pages/Leads';
import { Layout } from './components/Layout';
import { useAuthStore } from './lib/auth.store';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const accessToken = useAuthStore((s) => s.accessToken);
  if (!accessToken) return <Navigate to="/login" replace />;
  return children;
};

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="agent" element={<AgentSettings />} />
        <Route path="knowledge" element={<KnowledgeBase />} />
        <Route path="conversations" element={<Conversations />} />
        <Route path="leads" element={<Leads />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
